// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"AtCard_clickableCard__2MGw5","unClickableCard":"AtCard_unClickableCard__u1EIl","container":"AtCard_container__wSeOb"};